<template>
  <a-input class="my-input" :value="displayValue" @update:value="handleInput" allowClear :maxlength="30">
    <template v-for="(item, i) in Object.keys($slots)" v-slot:[item]="scope">
      <slot :name="item" v-bind="scope||{}"></slot>
    </template>
  </a-input>
</template>

<script setup>
  import { defineProps, defineEmits, watch, ref } from 'vue';
  const props = defineProps({
    modelValue: {
      type: [String, Number],
    },
    // 添加一个属性控制是否过滤空格
    filterSpace: {
      type: Boolean,
      default: true
    }
  });
  const emits = defineEmits(['update:modelValue']);

  // 用于显示的值，可能与modelValue不同（当启用filterSpace时）
  const displayValue = ref(props.modelValue || '');

  // 监听modelValue变化，同步displayValue
  watch(() => props.modelValue, (newVal) => {
    if (props.filterSpace) {
      // 如果启用了过滤空格，则过滤掉空格后显示
      displayValue.value = String(newVal || '').replace(/\s/g, '');
    } else {
      displayValue.value = newVal || '';
    }
  }, { immediate: true });

  // 处理输入事件
  const handleInput = (value) => {
    if (props.filterSpace) {
      // 过滤空格
      const filteredValue = value.replace(/\s/g, '');
      displayValue.value = filteredValue;
      // 发出过滤后的值
      emits('update:modelValue', filteredValue);
    } else {
      // 不过滤空格，保持原来的行为
      emits('update:modelValue', value);
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
